angular
    .module('BBPublicBooking')
    .controller('TimeList', TimeListCtrl);

function TimeListCtrl(
    $attrs,
    $scope,
    $rootScope,
    TimeService,
    AlertService,
    BBModel,
    DateTimeUtilitiesService,
    LoadingService,
    ErrorService,
    $translate,
    bbWidgetPage,
    bbCalendarUtility
) {
    'ngInject';

    const loader = LoadingService.$loader($scope);

    $scope.options = $scope.$eval($attrs.bbTimes) || {};

    let currentSlot = null;


    /*
      To solve the happened race condition by several calls of the loadDay via event & initialization
     */
    this.onInitCheckRequestedSlot = false;

    $rootScope.connection_started.then(() => {

        if (!$scope.data_source) {
            $scope.data_source = $scope.bb.current_item;
        }

        if ($scope.bb.current_item.defaults.date && !$scope.bb.current_item.date) {
            $scope.setDate($scope.bb.current_item.defaults.date);
        } else if ($scope.bb.current_item.date) {
            $scope.setDate($scope.bb.current_item.date.date);
        } else {
            $scope.setDate(moment());
        }

        this.onInitCheckRequestedSlot = true;
        return $scope.loadDay();
    })
    .catch((err) => {
        loader.setLoadedAndShowError(err, 'Sorry, something went wrong');
    });


    /***
     * @ngdoc method
     * @name setDate
     * @methodOf BB.bbTimes
     * @description
     * Set the date the time list reprents
     *
     * @param {moment} date the date to set the time list to use
     */
    $scope.setDate = (date) => {
        const day = new BBModel.Day({date, spaces: 1});
        $scope.selected_day = day;
        return $scope.selected_date = day.date;
    };


    /***
     * @ngdoc method
     * @name setDataSource
     * @methodOf BB.bbTimes
     * @description
     * Set data source model of time list
     *
     * @param {object} source The source
     */
    $scope.setDataSource = (source) => {
        return $scope.data_source = source;
    };

    /***
     * @ngdoc method
     * @name setItemLinkSource
     * @methodOf BB.bbTimes
     * @description
     * Set item link source model
     *
     * @param {object} source The source
     */
    $scope.setItemLinkSource = (source) => {
        return $scope.item_link_source = source;
    };


    $scope.$on('dateChanged', (event, newdate) => {
            $scope.setDate(newdate);
            $scope.loadDay();
        }
    );


    // when the current item is updated, reload the time data
    $scope.$on('currentItemUpdate', event => $scope.loadDay({check_requested_slot: false}));


    /***
     * @ngdoc method
     * @name selectSlot
     * @methodOf BB.bbTimes
     * @description
     * Select the slot from time list in according of slot and route parameters
     *
     * @param {TimeSlot} slot The slot
     * @param {string} A specific route to load
     */
    $scope.selectSlot = (slot, day, route) => {

        if (slot && (slot.availability() > 0)) {

            currentSlot = slot;

            // if this time cal was also for a specific item source (i.e.a person or resoure- make sure we've selected it)
            if ($scope.item_link_source) {
                $scope.data_source.setItem($scope.item_link_source);
            }

            if (slot.datetime) {
                $scope.setLastSelectedDate(slot.datetime);
                $scope.data_source.setDate({date: slot.datetime});
            } else if (day) {
                $scope.setLastSelectedDate(day.date);
                $scope.data_source.setDate(day);
            }

            $scope.data_source.setTime(slot);
            if ($scope.data_source.reserve_ready) {
                loader.notLoaded();
                $scope.addItemToBasket().then(() => {

                    if (bbWidgetPage.canAutoDecideNextPage('bb-times')) {

                        $scope.decideNextPage(route);

                    }
                }).finally(() => loader.setLoaded());
            } else {
                if (bbWidgetPage.canAutoDecideNextPage('bb-times')) {
                    $scope.decideNextPage(route);
                }
            }
        }
    };

    /***
     * @ngdoc method
     * @name highlightSlot
     * @methodOf BB.bbTimes
     * @description
     * The highlight slot from time list
     *
     * @param {TimeSlot} slot The slot
     */
    $scope.highlightSlot = (slot, day) => {
        if (slot && (slot.availability() > 0)) {
            if (slot.datetime) {
                $scope.setLastSelectedDate(slot.datetime);
                $scope.data_source.setDate({date: slot.datetime});
            } else if (day) {
                $scope.setLastSelectedDate(day.date);
                $scope.data_source.setDate(day);
            }

            $scope.data_source.setTime(slot);

            // tell any accordion groups to update
            $rootScope.$broadcast('slotChanged', day, slot);
        }
    };

    /***
     * @ngdoc method
     * @name status
     * @methodOf BB.bbTimes
     * @description
     * Check the status of the slot to see if it has been selected
     *
     * @param {date} slot The slot
     */
    // check the status of the slot to see if it has been selected
    $scope.status = function (slot) {
        if (!slot) {
            return;
        }
        const status = slot.status();
        return status;
    };


    /***
     * @ngdoc method
     * @name add
     * @methodOf BB.bbTimes
     * @description
     * Add unit of time to the selected day
     *
     * @param {date} type The type
     * @param {date} amount The amount
     */
    // add unit of time to the selected day
    $scope.add = (type, amount) => {

        // clear existing time
        delete $scope.bb.current_item.time;

        const new_date = moment($scope.selected_day.date).add(amount, type);
        $scope.setDate(new_date);
        $scope.loadDay();
    };

    /***
     * @ngdoc method
     * @name subtract
     * @methodOf BB.bbTimes
     * @description
     * Subtract unit of time to the selected day
     *
     * @param {date} type The type
     * @param {date} amount The amount
     */
    // subtract unit of time to the selected day
    $scope.subtract = (type, amount) => {
        return $scope.add(type, -amount);
    };

    /***
     * @ngdoc method
     * @name loadDay
     * @methodOf BB.bbTimes
     * @description
     * Load day
     */
    $scope.loadDay = (options) => {

        options = options || {check_requested_slot: true};

        /**
         * check if user can show past dates to book
         */
        $scope.canShowPrevDates = bbCalendarUtility.canShowPreviousDates({
            currentItem: $scope.bb.current_item,
            selectedDate: $scope.selected_date
        });


        if (this.$DayListCtrl && $scope.bb.current_item.service.duration_unit === 'day') {
            loader.setLoaded();
            return;
        }

        if (!this.onInitCheckRequestedSlot && angular.isDefined(options.check_requested_slot)) {
            options = {check_requested_slot: options.check_requested_slot};
        } else if (this.onInitCheckRequestedSlot) {
            options = {check_requested_slot: true};
        }

        if ($scope.data_source && ($scope.data_source.days_link || $scope.item_link_source) && $scope.selected_day) {

            // Return if calendar is currently being displayed for
            // multiple days. ie: 3/5/7 day tabs in calendar modal.
            if ($scope.calendar_view && $scope.calendar_view.multi_day) {
                return;
            }

            loader.notLoaded();

            const pslots = TimeService.query({
                company: $scope.bb.company,
                cItem: $scope.data_source,
                item_link: $scope.item_link_source,
                date: $scope.selected_day.date,
                client: $scope.client,
                available: 1,
                people_ids: $scope.bb.item_defaults.people_ids
            });

            pslots.then(
                (time_slots) => {

                    // Ensure to return an array of slots only for a selected day since time_slots may be a range of dates
                    let selectedDayTimeSlots = time_slots.constructor === Array ? time_slots : time_slots[$scope.selected_date.toISODate()];
                    if (!bbCalendarUtility.canMakePastBookings()){
                        selectedDayTimeSlots = selectedDayTimeSlots.filter(slot => slot.datetime.isAfter(moment()));
                    }
                    $scope.slots = selectedDayTimeSlots;

                    $scope.$broadcast('slotsUpdated', $scope.data_source, selectedDayTimeSlots); // data_source is the BasketItem
                    // padding is used to ensure that a list of time slots is always padded out with a certain of values, if it's a partial set of results
                    if ($scope.add_padding && (selectedDayTimeSlots.length > 0)) {
                        const dtimes = {};
                        for (const s of Array.from(selectedDayTimeSlots)) {
                            dtimes[s.time] = 1;
                        }

                        for (let v = 0; v < $scope.add_padding.length; v++) {
                            const pad = $scope.add_padding[v];
                            if (!dtimes[pad]) {
                                selectedDayTimeSlots.splice(v, 0, new BBModel.TimeSlot({
                                    time: pad,
                                    avail: 0
                                }, selectedDayTimeSlots[0].service));
                            }
                        }
                    }

                    if (options.check_requested_slot === true) {
                        /*
                          Setting the onInitCheckRequestedSlot flag to false to make other parts of system work properly
                         */
                        this.onInitCheckRequestedSlot = false;

                        checkRequestedSlots(selectedDayTimeSlots);
                    }

                    loader.setLoaded();
                })
                .catch((err) => {
                    if ((err.status === 404) && err.data && err.data.error && (err.data.error === 'No bookable events found')) {
                        if ($scope.data_source && $scope.data_source.person) {
                            AlertService.warning(ErrorService.getError('NOT_BOOKABLE_PERSON'));
                            loader.setLoaded();
                        } else if ($scope.data_source && $scope.data_source.resource) {
                            AlertService.warning(ErrorService.getError('NOT_BOOKABLE_RESOURCE'));
                            loader.setLoaded();
                        } else {
                            loader.setLoadedAndShowError(err, 'Sorry, something went wrong');
                        }
                    } else {
                        loader.setLoadedAndShowError(err, 'Sorry, something went wrong');
                    }
                }
            );

        }
    };

    let checkRequestedSlots = function (time_slots) {
        if (!$scope.bb.item_defaults || !$scope.bb.item_defaults.time) {
            return;
        }

        const requested_slot = DateTimeUtilitiesService.checkDefaultTime($scope.selected_date, time_slots, $scope.data_source, $scope.bb.item_defaults);

        if ((requested_slot.slot === null) || (requested_slot.match === null)) {
            return $scope.availability_conflict = true;
        } else if (requested_slot.slot && (requested_slot.match === 'full')) {
            $scope.skipThisStep();
            return $scope.selectSlot(requested_slot.slot, $scope.selected_day);
        } else if (requested_slot.slot && (requested_slot.match === 'partial')) {
            return $scope.highlightSlot(requested_slot.slot, $scope.selected_day);
        }
    };

    /***
     * @ngdoc method
     * @name isCurrentTimeSlot
     * @methodOf BB.isCurrentTimeSlot
     * @description
     * Is the slot the currently selected slot
     *
     * @param {TimeSlot} slot
     */
    $scope.isCurrentTimeSlot = (slot) => {
        return currentSlot && slot.time == currentSlot.time;
    };

    /***
     * @ngdoc method
     * @name padTimes
     * @methodOf BB.bbTimes
     * @description
     * Pad Times in according of times parameter
     *
     * @param {date} times The times
     */
    $scope.padTimes = (times) => {
        return $scope.add_padding = times;
    };


    /***
     * @ngdoc method
     * @name setReady
     * @methodOf BB.bbTimes
     * @description
     * Set this page section as ready
     */
    $scope.setReady = () => {
        if ($scope.bb.current_item.date && $scope.bb.current_item.date.event_id) {
            return true;
        } else if (!$scope.data_source.time) {
            AlertService.clear();
            AlertService.add('danger', {msg: $translate.instant('PUBLIC_BOOKING.TIME.TIME_NOT_SELECTED_ALERT')});
            return false;
        } else {
            if ($scope.data_source.reserve_ready) {
                return $scope.addItemToBasket();
            } else {
                return true;
            }
        }
    };
}


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/times/bb_times.controller.js